import axios from 'axios';
import Cookies from 'js-cookie'
import { Message } from 'element-ui';

import { checkJWTValue, toLogin } from '@/assets/js/jwt';
const errorCode = [2001]

const service = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? '' : process.env.API_ROOT,
  timeout: 25000,
});
service.interceptors.request.use(
  async config => {
    // console.log(config.headers,'--------------看看');
    await checkJWTValue(config.url);
    //支持自定义header
    if(config.header){
      config.headers = {
        ...config.headers,
        ...config.header
      }
    }
    if (process.env.VUE_APP_EVN === 'sandbox' || process.env.VUE_APP_EVN === 'staging_sandbox'){
      config.headers['Cv-Account-Token'] = getQuery('cv_account_token');
    } else if (Cookies.get('_t')){
      config.headers['Authorization'] = Cookies.get('_t')
    }

    // 导师jwt
    // config.headers['Authorization'] = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJVc2VyIjp7InQiOiJjZWMwYjRhNDhmZTM0NWM4OWNhNzQ5MDJjYzYzOTM4MiIsImNfdCI6ImN2ZThhNGY1OWZlMzNjNDBjIiwiaF90IjoiaHI1MWU4MDUzOTI4N2Y0NDgifSwiZXhwIjoxNzQ0MzU0NjcyfQ.PPq17O7e40pEU1-mIgw7bsfMNOb3YDzbB3uj9zxXCnk'


      config.withCredentials = true;
    // if(config.url.includes('/v1/nps')){
    //   config.url=config.url;add
    // }else{
      config.url = (process.env.NODE_ENV === 'development' && !config.url.includes('/health/cip') ? '/api' : '') + config.url;

    // }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  response => {
    let responseData = response.data;
    if(errorCode.includes(responseData.code)){
      // toLogin({login:true});
      // Message({
      //   message: '请重新登录',
      //   type: 'error'
      // });
      // setTimeout(() => {
      //   toLogin();
      // }, 1000);
    }
    return responseData;
  },
  error => {
    return Promise.reject(error);
  }
);


//获取url某个参数
let getQuery = (auth_token)=>{
  let queryString = window.location.search;
  if(!queryString.includes(auth_token) || !queryString.includes('?')){
    return '';
  }
  let queryStrings = queryString.split('?')[1].split('&');
  let query = {};
  queryStrings.forEach(item=>{
    let value = item.split('=');
    query[value[0]] = value[1]
  })
  return query[auth_token] || ''
}

export default service;
